import { FC } from "react";
import { TransactionListItemDto } from "../../../../common/types/transaction";
import { Loader } from "../../../general/Loader";
import { useReceiptUpload } from "../../../transactions/ReceiptUpload/useReceiptUpload";
import { Button } from "../../../general/Button/Button";
import { FinancialDocument } from "../../../../common/types/financialDocument";

interface Props {
    uploading: boolean;
    transaction: TransactionListItemDto;
    receipt: FinancialDocument | null;
}

export const ReceiptColumn: FC<Props> = ({ uploading, receipt }) => {
    const { open, inputProps } = useReceiptUpload();

    if (uploading) {
        return <Loader inline />;
    }

    if (receipt) {
        return <Button variant="secondary">Uploaded</Button>;
    }

    return (
        <>
            <Button variant="action" onClick={open}>
                Upload
            </Button>
            <input {...inputProps} />
        </>
    );
};
